/**
 * Cart view
 */
module.config(['$stateProvider', 'urls', function ($stateProvider, urls) {
    'use strict';
    $stateProvider.state('cart', {
        url: '/' + urls.cart.fr, // TODO : when multilang, change this to something dynamic
        controller: ['$rootScope', '$scope', 'cart', 'headermanager', 'tools', '$filter', 'drupal', function ($rootScope, $scope, $cart, $headermanager, tools, $filter, drupal) {
            $scope.tools = tools;
            $scope.loading = false;

            $scope.config = $rootScope.config.site;

            $headermanager.customize({
                filled: true
            });

            $scope.membershipReminder = {
                value: ''
            };
            $scope.breadcrumb = [
                { label: $filter('translate')('home'), state: 'homepage' },
                { label: $filter('translate')('cart.title') }
            ];
            $scope.titlePanel = $filter('translate')('cart.title');
            $scope.teaserPanel = {};
            var configWatcher = $rootScope.$watch('config.site.cart_messages', function (config) {
                if (config) {
                    angular.merge($scope.teaserPanel, { css: 'info', body: config.membership_message.value });
                    $scope.membershipReminder.value = config.recap_membership_message.value;
                }
            });
            $scope.$on('$destroy', function () {
                configWatcher();
            });

            $scope.upsellInternships = {
                title: $filter('translate')('cart.upsellTitle'),
                field_internships: []
            };

            // retrieve cart
            $scope.cart = $cart;

            $scope.$watch('cart.internships', function (internships) {
                $scope.upsellInternships.field_internships.length = 0;
                internships.forEach(function (internship) {
                    internship.field_internship.field_linked_products = [];
                    drupal.getProductRelated(internship.field_internship.product.sfid, internship.id).then(function (products) {
                        products.forEach(function (product) {
                            if (product.type === 'internship') {
                                if (!internships.some(function (internship) {
                                    return internship.field_internship.product.sfid === product.sfid;
                                })) {
                                    $scope.upsellInternships.field_internships.push({ product: product });
                                }
                            } else if (product.type === 'product') {
                                internship.field_internship.field_linked_products.push(product);
                            }
                        });
                    });
                });
            });

            // Callback function to check internship id
            $scope.internshipIdEquals = function (internshipId) {
                return function (element) {
                    return internshipId === element.field_internship.id;
                };
            };

            // Callback function to check product id
            $scope.productIdEquals = function (productId) {
                return function (element) {
                    return productId === element.id;
                };
            };

            // Function that returns the product if in cart
            $scope.productInCart = function (product) {
                return $scope.cart.products.find($scope.productIdEquals(product.id));
            };

            // Add product to cart
            $scope.addProduct = function (product) {
                if (!product.pending) {
                    product.pending = true;
                    $scope.cart.addProduct(product).then(function () {
                        product.pending = false;
                    });
                }
            };

            // Delete internship from cart
            $scope.deleteInternship = function (internshipId) {
                $scope.cart.internships.splice($scope.cart.internships.findIndex($scope.internshipIdEquals(internshipId)), 1);
                $scope.updateTotal();
            };

            // Remove product from cart
            $scope.removeProduct = function (product) {
                if (!product.pending) {
                    product.pending = true;
                    $scope.cart.removeProduct(product);
                }
            };

            $scope.updateTotal = function () {
                $scope.cart.update();
            };

            $scope.isMembership = function(product) {
                return tools.filterMembership(product.field_product);
            }
        }],
        templateUrl: 'src/views/cart/cart.html'
    });
}]);
